import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { logger } from '@utils/logger';

const log = logger.createLogger('Main');

log.info('Starting application initialization');

log.debug('Environment info', {
  Mode: import.meta.env.MODE,
  Base: import.meta.env.BASE_URL,
  Dev: import.meta.env.DEV,
  Prod: import.meta.env.PROD,
  Url: window.location.href,
  Pathname: window.location.pathname,
});

// Ensure the root element exists
const rootElement = document.getElementById('root')

if (!rootElement) {
  log.error('Root element not found');
  document.body.innerHTML = `
    <div style="text-align: center; padding: 50px; font-family: sans-serif;">
      <h1 style="color: #d66a22;">Unified DNS</h1>
      <p style="color: #ff4d4f;">Error: Root element not found</p>
      <p>Please ensure the application is properly configured.</p>
    </div>
  `
  throw new Error('Root element not found')
}

log.debug('Root element found');

// Try to import and render the App
try {
  log.debug('Attempting to import App component');
  
  import('./App').then(
    (module) => {
      log.debug('App component imported successfully');
      const App = module.default;
      
      try {
        ReactDOM.createRoot(rootElement).render(
          <React.StrictMode>
            <App />
          </React.StrictMode>
        );
        log.info('Application mounted successfully');
      } catch (renderError) {
        log.error('Failed to render App', { Error: String(renderError) });
        throw renderError;
      }
    },
    (importError) => {
      log.error('Failed to import App', { Error: String(importError) });
      
      // Show a fallback UI
      ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
          <div style={{ 
            padding: '40px', 
            textAlign: 'center',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            minHeight: '100vh',
            background: '#f8f9fa'
          }}>
            <h1 style={{ color: '#d66a22', marginBottom: '20px' }}>
              Unified DNS
            </h1>
            <div style={{ 
              background: 'white',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              padding: '30px',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              <h2 style={{ color: '#dc3545', marginBottom: '15px' }}>
                ⚠️ Application Loading Error
              </h2>
              <p style={{ marginBottom: '20px' }}>
                There was an issue loading the application. This could be due to:
              </p>
              <ul style={{ textAlign: 'left', lineHeight: '1.8' }}>
                <li>Missing dependencies</li>
                <li>Import path issues</li>
                <li>TypeScript compilation errors</li>
              </ul>
              <div style={{ 
                background: '#f8f9fa',
                padding: '15px',
                borderRadius: '4px',
                marginTop: '20px',
                fontFamily: 'monospace',
                fontSize: '12px',
                textAlign: 'left',
                color: '#dc3545'
              }}>
                {importError instanceof Error ? importError.message : 'Unknown import error'}
              </div>
              <div style={{ marginTop: '30px' }}>
                <p style={{ marginBottom: '15px' }}>Try these direct links:</p>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  <a 
                    href="/auth/login" 
                    style={{ 
                      padding: '10px 20px',
                      background: '#d66a22',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '4px',
                      display: 'inline-block'
                    }}
                  >
                    Login Page
                  </a>
                  <button 
                    onClick={() => window.location.reload()} 
                    style={{
                      padding: '10px 20px',
                      background: '#6c757d',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Reload Page
                  </button>
                </div>
              </div>
            </div>
            <p style={{ color: '#6c757d', marginTop: '30px' }}>
              Check the browser console (F12) for detailed error information.
            </p>
          </div>
        </React.StrictMode>
      );
    }
  );
} catch (error) {
  log.error('Unexpected error during initialization', { Error: String(error) });
  
  // Show error in the UI
  rootElement.innerHTML = `
    <div style="text-align: center; padding: 50px; font-family: sans-serif;">
      <h1 style="color: #d66a22;">Unified DNS</h1>
      <p style="color: #ff4d4f;">Failed to initialize application</p>
      <p>Error: ${error instanceof Error ? error.message : 'Unknown error'}</p>
      <p style="margin-top: 20px; color: #666;">
        Please check the console for more details or try refreshing the page.
      </p>
      <button 
        onclick="window.location.reload()" 
        style="
          margin-top: 20px;
          padding: 10px 20px;
          background: #d66a22;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        "
      >
        Refresh Page
      </button>
    </div>
  `;
}
